import { HelpTip } from "@amzn/storm-ui";

export const ApbHelpTip: React.FunctionComponent = () => {
    return (
        <HelpTip>
            There are 1-click recommendations related to this insight deck that
            you can customize and send to advertisers.
        </HelpTip>
    );
};
